(function () {
    'use strict';

    angular.module('product')
        .controller('PackageUpdateController', PackageUpdateController);

    PackageUpdateController.$inject = ['$state', 'packageDataSrvc', 'notificationSrvc', 'packageMessagesConst', 'errorNotificationSrvc'];

    function PackageUpdateController($state, packageDataSrvc, notificationSrvc, packageMessagesConst, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            name: [],
            width: [],
            height: [],
            length: [],
            max_weight: [],
            nonFieldErrors: []
        };

        self.packageData = {};

        self.inlineInputFields = [
            {
                prop: 'width',
                type: 'number',
                title: 'Szerokość',
                isRequired: false,
                isDisabled: false,
                minValue: 1,
                onChange: cleanErrors
            },
            {
                prop: 'height',
                type: 'number',
                title: 'Wysokość',
                isRequired: false,
                isDisabled: false,
                minValue: 1,
                onChange: cleanErrors
            },
            {
                prop: 'length',
                type: 'number',
                title: 'Długość',
                isRequired: false,
                isDisabled: false,
                minValue: 1,
                onChange: cleanErrors
            }
        ];

        self.updatePackage = updatePackage;
        self.cleanErrors = cleanErrors;

        activate();

        function activate() {
            getPackage();
        }

        function getPackage() {
            return packageDataSrvc.get({
                pk: $state.params.pk
            }).$promise.then(function (response) {
                self.packageData = response;
                delete self.packageData.date_added;
                delete self.packageData.date_modified;
                return response;
            });
        }

        function updatePackage() {
            packageDataSrvc.update({
                pk: self.packageData.pk
            }, self.packageData).$promise.then(
                function (response) {
                    notificationSrvc.notification("success", packageMessagesConst.update);
                    $state.go('layout.package.list');
                },
                function (response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
